import AbstractAppError from './AbstractAppError';

export default class InvalidHealthCenterError extends AbstractAppError {
  constructor() {
    super('INVALID_HEALTH_CENTER', 'errors.invalidHealthCenter');
  }
}
